export default function BugIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.386 2.643a.75.75 0 1 0-.772-1.286L14.27 2.764A5.2 5.2 0 0 0 12 2.25a5.2 5.2 0 0 0-2.269.514L7.386 1.357a.75.75 0 0 0-.772 1.286l1.763 1.058A5.24 5.24 0 0 0 6.75 7.5v.29q-.386.204-.725.473a.8.8 0 0 0-.246-.16l-2-.8a.75.75 0 0 0-.558 1.392l1.772.709c-.47.73-.743 1.6-.743 2.533v1.312H2a.75.75 0 0 0 0 1.5h2.25V15c0 1.28.31 2.486.859 3.55l-1.888.754a.75.75 0 1 0 .558 1.393l2-.8a1 1 0 0 0 .149-.08A7.74 7.74 0 0 0 12 22.75a7.74 7.74 0 0 0 6.072-2.934 1 1 0 0 0 .15.08l2 .8a.75.75 0 0 0 .556-1.392l-1.886-.755A7.7 7.7 0 0 0 19.75 15v-.25H22a.75.75 0 0 0 0-1.5h-2.25v-1.312c0-.934-.273-1.803-.743-2.533l1.771-.709a.75.75 0 0 0-.556-1.392l-2 .8a.8.8 0 0 0-.247.16 4.7 4.7 0 0 0-.725-.473V7.5a5.24 5.24 0 0 0-1.627-3.8zM5.75 15v-3.062A3.187 3.187 0 0 1 8.938 8.75h6.124a3.19 3.19 0 0 1 3.188 3.188V15a6.25 6.25 0 0 1-5.5 6.206V15a.75.75 0 0 0-1.5 0v6.206A6.25 6.25 0 0 1 5.75 15M12 3.75a3.75 3.75 0 0 1 3.745 3.55 5 5 0 0 0-.682-.05H8.936q-.347 0-.682.05A3.75 3.75 0 0 1 12 3.75"
        fill="currentColor"
      />
    </svg>
  );
}
